import styled from 'styled-components'

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['16'],
}))

export const List = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
}))

export const Group = styled.section(({ theme }) => ({
  backgroundColor: theme.colors.white,
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
}))

export const Header = styled.button<{ $isOpen: boolean }>(({ theme, $isOpen }) => ({
  '&:disabled': {
    cursor: 'default',
  },
  '&:focus-visible': {
    outline: `${theme.border.size['2']} solid ${theme.colors.blue500}`,
    outlineOffset: `-${theme.border.size['2']}`,
  },
  alignItems: 'center',
  backgroundColor: $isOpen ? theme.colors.gray100 : theme.colors.white,
  border: 'none',
  borderRadius: $isOpen
    ? `${theme.border.radius['12']} ${theme.border.radius['12']} 0 0`
    : theme.border.radius['12'],
  boxSizing: 'border-box',
  color: theme.colors.black800,
  cursor: 'pointer',
  display: 'flex',
  flexWrap: 'wrap',
  gap: `${theme.space['12']} ${theme.space['20']}`,
  minHeight: theme.space['64'],
  padding: `${theme.space['16']} ${theme.space['20']}`,
  textAlign: 'left',
  width: '100%',
}))

export const HeaderMain = styled.span(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flex: '1 1 28rem',
  gap: theme.space['12'],
  minWidth: 0,
}))

export const ChevronBox = styled.span(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.gray300,
  borderRadius: theme.border.radius['8'],
  color: theme.colors.black400,
  display: 'flex',
  flexShrink: 0,
  height: theme.space['28'],
  justifyContent: 'center',
  width: theme.space['28'],
}))

export const HeaderText = styled.span(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
  minWidth: 0,
}))

export const Summary = styled.span(({ theme }) => ({
  color: theme.colors.primary600,
  fontSize: '1.3rem',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const Progress = styled.span(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexShrink: 0,
  gap: theme.space['14'],
}))

export const ProgressCount = styled.span(({ theme }) => ({
  color: theme.colors.black600,
  fontSize: '1.4rem',
  fontWeight: 600,
  minWidth: theme.space['64'],
  textAlign: 'right',
  whiteSpace: 'nowrap',
}))

export const Body = styled.div(({ theme }) => ({
  alignItems: 'start',
  borderTop: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'grid',
  gap: `${theme.space['10']} ${theme.space['16']}`,
  gridTemplateColumns: 'repeat(auto-fill, minmax(28rem, 1fr))',
  padding: `${theme.space['16']} ${theme.space['20']} ${theme.space['20']}`,
}))

export const Card = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['10'],
  padding: `${theme.space['4']} ${theme.space['4']} ${theme.space['4']} ${theme.space['14']}`,
}))

export const Row = styled.div<{ $isChild?: boolean }>(({ theme, $isChild }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['10'],
  minHeight: $isChild ? theme.space['40'] : theme.space['48'],
  paddingRight: theme.space['6'],
}))

export const RowLabel = styled.span<{ $isChild?: boolean }>(({ theme, $isChild }) => ({
  color: $isChild ? theme.colors.black600 : theme.colors.black800,
  flex: 1,
  fontSize: $isChild ? '1.3rem' : '1.5rem',
  fontWeight: $isChild ? 400 : 700,
  minWidth: 0,
}))

export const RowMessage = styled.div<{ $error?: boolean }>(({ theme, $error }) => ({
  color: $error ? theme.colors.red500 : theme.colors.primary600,
  fontSize: '1.1rem',
  paddingBottom: theme.space['6'],
}))

export const Children = styled.div(({ theme }) => ({
  borderTop: `${theme.border.size['1']} dashed ${theme.colors.gray600}`,
  // Note: no right margin, so the child switches line up with the parent's switch
  margin: `${theme.space['2']} 0 ${theme.space['4']}`,
  paddingLeft: theme.space['14'],
  paddingTop: theme.space['2'],
}))

export const ChildBullet = styled.span(({ theme }) => ({
  color: theme.colors.gray800,
  display: 'flex',
  flexShrink: 0,
}))

export const TooltipHint = styled.span(({ theme }) => ({
  display: 'block',
  marginTop: theme.space['4'],
}))
